<template>
  <div v-if="isPermission">
    <div class="booking-settings-container">
      <div class="header-section">
        <div>
          <h2>{{ $t('receiptSetting.title') }}</h2>
        </div>
        <button @click="confirmModal = true" class="btn-save" :disabled="loading" v-if="isEditShop">
          {{ loading ? $t('saving') : $t('receiptSetting.saveSettings') }}
        </button>
      </div>

      <CAlert color="info" class="info-alert">
        <i class="fi fi-rr-info mr-2"></i>
        {{ $t('receiptSetting.branchSyncNotice') }}
        <br/>
        <small>
          <i class="fi fi-rr-desktop mr-1"></i>
          {{ $t('receiptSetting.posSettingNotice') }}
        </small>
      </CAlert>

      <CRow class="receipt-layout">
        <!-- ─── col-lg-7: ส่วนตั้งค่า ─── -->
        <CCol lg="7">
          <div class="scrollable-content">
            <!-- ─── Section: การพิมพ์ทั่วไป ─── -->
            <div class="section-card">
              <h3><span>🖨️</span> {{ $t('receiptSetting.printSection') }}</h3>
              <div class="form-row border-bottom">
                <span class="desc-main">{{ $t('receiptSetting.showQueueOnReceipt') }}</span>
                <label class="c-switch c-switch-label c-switch-pill c-switch-success m-0">
                  <input type="checkbox" class="c-switch-input" v-model="datashop.showQueueOnReceipt">
                  <span class="c-switch-slider" data-checked="On" data-unchecked="Off"></span>
                </label>
              </div>
              <div class="form-row border-bottom">
                <span class="desc-main">{{ $t('receiptSetting.showBarcodeReceipt') }}</span>
                <label class="c-switch c-switch-label c-switch-pill c-switch-success m-0">
                  <input type="checkbox" class="c-switch-input" v-model="datashop.showBarcodeReceipt">
                  <span class="c-switch-slider" data-checked="On" data-unchecked="Off"></span>
                </label>
              </div>
              <!-- เงื่อนไขตาม receiptType = 2 -->
              <div v-if="datashop.receiptType === 2" >
                <div class="form-row border-bottom">
                  <span class="desc-main">{{ $t('receiptSetting.showVATOnReceipt') }}</span>
                  <label class="c-switch c-switch-label c-switch-pill c-switch-success m-0">
                    <input type="checkbox" class="c-switch-input" v-model="datashop.showVATOnReceipt">
                    <span class="c-switch-slider" data-checked="On" data-unchecked="Off"></span>
                  </label>
                </div>
                <div class="form-row ">
                  <label class="input-label">{{ $t('receiptSetting.headerText') }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="datashop.header"
                    :placeholder="$t('receiptSetting.headerPlaceholder')"
                  />
                </div>
              </div>
            </div>
            <!-- ─── Section: แสดงรายละเอียดบนใบเสร็จ ─── -->
            <div class="section-card">
              <h3><span>📋</span> {{ $t('receiptSetting.detailSection') }}</h3>
              <div class="form-row border-bottom">
                <span class="desc-main">{{ $t('receiptSetting.showDetailOnReceipt') }}</span>
                <label class="c-switch c-switch-label c-switch-pill c-switch-success m-0">
                  <input type="checkbox" class="c-switch-input" v-model="datashop.showDetailOnReceipt">
                  <span class="c-switch-slider" data-checked="On" data-unchecked="Off"></span>
                </label>
              </div>
              <div class="form-row border-bottom">
                <span class="desc-main">{{ $t('receiptSetting.showNoteOnReceipt') }}</span>
                <label class="c-switch c-switch-label c-switch-pill c-switch-success m-0">
                  <input type="checkbox" class="c-switch-input" v-model="datashop.showNoteOnReceipt">
                  <span class="c-switch-slider" data-checked="On" data-unchecked="Off"></span>
                </label>
              </div>
              <div class="form-row border-bottom">
                <span class="desc-main">{{ $t('receiptSetting.showOptionGroupOnReceipt') }}</span>
                <label class="c-switch c-switch-label c-switch-pill c-switch-success m-0">
                  <input type="checkbox" class="c-switch-input" v-model="datashop.showOptionGroupOnReceipt">
                  <span class="c-switch-slider" data-checked="On" data-unchecked="Off"></span>
                </label>
              </div>
              <div class="form-group mt-3">
                <label class="input-label">{{ $t('receiptSetting.wordingToReplace') }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="datashop.wordingToReplace"
                  :placeholder="$t('receiptSetting.wordingPlaceholder')"
                />
              </div>
            </div>



            <!-- ─── Section: ท้ายบิล (Footer) ─── -->
            <div class="section-card">
              <h3><span>📝</span> {{ $t('receiptSetting.footerSection') }}</h3>
              <div class="form-group mb-3">
                <label class="input-label">{{ $t('receiptSetting.footer1Label') }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="datashop.footer1"
                  :placeholder="$t('receiptSetting.footer1Placeholder')"
                />
              </div>
              <div class="form-group mb-3">
                <label class="input-label">{{ $t('receiptSetting.footer2Label') }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="datashop.footer2"
                  :placeholder="$t('receiptSetting.footer2Placeholder')"
                />
              </div>
            </div>
            <!-- ─── Section: รูปภาพท้ายใบเสร็จ ─── -->
            <div class="section-card">
              <h3><span>🖼️</span> {{ $t('receiptSetting.footerImageSection') }}</h3>
              <div class="notice-box">
                <i class="fi fi-rr-info"></i>
                <span>{{ $t('receiptSetting.footerImageNotice') }}</span>
              </div>
              <div class="footer-images-grid">
                <!-- Footer Image 1 -->
                <div class="footer-image-box">
                  <label class="input-label">{{ $t('receiptSetting.footerImage1') }}</label>
                  <div class="image-upload-area" @click="triggerUpload('footer1')" style="position: relative;">
                    <img
                      v-if="datashop.footerRemoteImagePath1"
                      :src="datashop.footerRemoteImagePath1"
                      alt="Footer Image 1"
                      class="preview-image"
                    />
                    <div v-else class="image-placeholder">
                      <i class="fi fi-rr-picture"></i>
                      <span>{{ $t('receiptSetting.clickToUpload') }}</span>
                    </div>
                    <button
                      v-if="datashop.footerRemoteImagePath1"
                      class="btn-remove-image-corner"
                      @click.stop="removeFooterImage(1)"
                    >
                      ✕
                    </button>
                  </div>
                </div>
                <!-- Footer Image 2 -->
                <div class="footer-image-box">
                  <label class="input-label">{{ $t('receiptSetting.footerImage2') }}</label>
                  <div class="image-upload-area" @click="triggerUpload('footer2')" style="position: relative;">
                    <img
                      v-if="datashop.footerRemoteImagePath2"
                      :src="datashop.footerRemoteImagePath2"
                      alt="Footer Image 2"
                      class="preview-image"
                    />
                    <div v-else class="image-placeholder">
                      <i class="fi fi-rr-picture"></i>
                      <span>{{ $t('receiptSetting.clickToUpload') }}</span>
                    </div>
                    <button
                      v-if="datashop.footerRemoteImagePath2"
                      class="btn-remove-image-corner"
                      @click.stop="removeFooterImage(2)"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              </div>
              <!-- Hidden file input -->
              <input
                ref="fileInput"
                type="file"
                accept="image/*"
                style="display: none"
                @change="onFileSelect"
              />
            </div>

                      <!-- ─── Section: เอกสารใบกำกับภาษี ─── -->
          <div class="section-card">
            <h3><span>📑</span> {{ $t('receiptSetting.taxInvoiceSection') }}</h3>
            <p class="desc-sub mb-3">{{ $t('receiptSetting.taxInvoiceSectionDesc') }}</p>

            <div class="form-group mb-3">
              <label class="input-label">{{ $t('receiptSetting.taxInvoiceName') }}</label>
              <input
                type="text"
                class="form-control"
                v-model="datashop.signatureName"
                :placeholder="$t('receiptSetting.taxInvoiceNamePlaceholder')"
              />
              <p class="desc-sub text-muted text-smaller mt-1" style="font-size: x-small;">{{ $t('receiptSetting.taxInvoiceNameDesc') }}</p>
            </div>

            <div class="form-group">
              <label class="input-label">{{ $t('receiptSetting.signatureImage') }}</label>
              <p class="desc-sub mb-2 text-muted " style="font-size: x-small;">{{ $t('receiptSetting.signatureImageDesc') }}</p>
              <div class="image-upload-area" @click="triggerUpload('signature')" style="position: relative; max-width: 300px; height: 120px;">
                <img
                  v-if="datashop.signatureRemoteImagePath"
                  :src="datashop.signatureRemoteImagePath"
                  alt="Signature"
                  class="preview-image"
                />
                <div v-else class="image-placeholder">
                  <i class="fi fi-rr-pen-nib"></i>
                  <span>{{ $t('receiptSetting.clickToUploadSignature') }}</span>
                </div>
                <button
                  v-if="datashop.signatureRemoteImagePath"
                  class="btn-remove-image-corner"
                  @click.stop="removeSignatureImage"
                >
                  ✕
                </button>
              </div>
              <!-- <div v-if="datashop.signatureImageName" class="image-filename mt-1">
                {{ datashop.signatureImageName }}
              </div> -->
            </div>
          </div>
          </div>
        </CCol>
        <!-- ─── col-lg-5: ส่วนแสดงตัวอย่าง ─── -->
        <CCol lg="5">
          <div class="preview-panel">
            <div class="preview-panel-header">
              <h3>{{ $t('receiptSetting.previewTitle') }}</h3>
            </div>

            <div class="preview-panel-body">
              <div class="receipt-paper">
                <!-- Logo -->
                <div v-if="datashop.showQueueOnReceipt" class="receipt-queue">
                  {{ $t('receiptSetting.previewQueue') }} 1
                </div>
                <div v-if="datashop.isPrintShopLogo && datashop.remoteImagePath" class="receipt-logo">
                  <img :src="datashop.remoteImagePath" alt="Shop Logo" class="logo-img" />
                </div>

                <!-- Shop Info -->

                <div class="receipt-shop-name">{{ datashop.shopName || $t('receiptSetting.previewShopName') }}</div>
                <div class="receipt-branch">{{ $t('receiptSetting.previewBranch') }}: {{ datashop.branchName || 'Headquarters' }}</div>
                <div class="receipt-type-label">
                  {{ datashop.receiptType === 2 ? (datashop.header || $t('receiptSetting.custom')) : receiptTypes[datashop.receiptType || 0] }}
                </div>
                <div class="receipt-divider"></div>
                <!-- Date & Invoice -->
                <div class="receipt-info-line">{{ $t('receiptSetting.previewDate') }}: {{ currentDate }}</div>
                <div class="receipt-info-line">Invoice #: PS00100001</div>
                <div class="receipt-info-line">POS #: 001 &nbsp;&nbsp;&nbsp;&nbsp; {{ $t('receiptSetting.previewCashier') }}: Admin</div>
                <div class="receipt-divider"></div>
                <!-- Sample Items -->
                <div class="receipt-items">
                  <div class="receipt-item-header">
                    <span>Qty {{ $t('receiptSetting.previewDescription') }}</span>
                    <span>Total</span>
                  </div>
                  <div class="receipt-item-row">
                    <span>2 &nbsp; Brown Fish Fillet</span>
                    <span>251.00</span>
                  </div>
                  <div class="receipt-item-sub">&nbsp;&nbsp;&nbsp;&nbsp;@125.50</div>
                  <div v-if="datashop.showBarcodeReceipt" class="receipt-item-plu">
                    &nbsp;&nbsp;&nbsp;&nbsp;PLU8677464545
                  </div>
                </div>
                <div class="receipt-divider"></div>
                <!-- Total -->
                <div class="receipt-total">
                  <span>{{ $t('receiptSetting.previewSubtotal') }}</span>
                  <span>251.00</span>
                </div>
                <!-- VAT (if applicable) -->
                <div v-if="datashop.showVATOnReceipt && datashop.receiptType === 2">
                  <div class="receipt-info-line text-right">{{ $t('receiptSetting.previewBeforeVat') }} &nbsp; 234.58</div>
                  <div class="receipt-info-line text-right">{{ $t('receiptSetting.previewTax7') }} &nbsp; 16.42</div>
                </div>
                <div class="receipt-total-big">
                  <span>{{ $t('receiptSetting.previewQty') }} 2 {{ $t('receiptSetting.previewPcs') }} &nbsp; {{ $t('receiptSetting.previewGrandTotal') }}</span>
                  <span class="receipt-total-amount">251.00</span>
                </div>
                <div class="receipt-divider"></div>
                <!-- Payment -->
                <div class="receipt-payment">
                  <div class="receipt-info-line"><strong>{{ $t('receiptSetting.previewPayment') }}</strong></div>
                  <div class="receipt-item-row">
                    <span>{{ $t('receiptSetting.previewCash') }}</span>
                    <span>500.00</span>
                  </div>
                  <div class="receipt-total-big">
                    <span>{{ $t('receiptSetting.previewChange') }}</span>
                    <span class="receipt-total-amount">249.00</span>
                  </div>
                </div>
                <div class="receipt-divider"></div>
                <!-- Note about VAT -->
                <div v-if="datashop.receiptType === 2" class="receipt-vat-note">
                  {{ $t('receiptSetting.previewVatIncluded') }}
                </div>
                <!-- Footer -->
                <div v-if="datashop.footer1" class="receipt-footer-text">
                  {{ datashop.footer1 }}
                </div>
                <div v-if="datashop.footer2" class="receipt-footer-text">
                  {{ datashop.footer2 }}
                </div>
                <!-- Footer Images -->
                <div v-if="datashop.footerRemoteImagePath1" class="receipt-footer-img">
                  <img :src="datashop.footerRemoteImagePath1" alt="Footer 1" />
                </div>
                <div v-if="datashop.footerRemoteImagePath2" class="receipt-footer-img">
                  <img :src="datashop.footerRemoteImagePath2" alt="Footer 2" />
                </div>
                <div class="receipt-powered">Powered by Silom POS</div>
              </div>
            </div>
          </div>
        </CCol>
      </CRow>
      <!-- ─── Modal: ยืนยันบันทึก ─── -->
      <CModal
        :show.sync="confirmModal"
        :title="$t('receiptSetting.confirmSave')"
        color="success"
        centered
      >
        <p>{{ $t('receiptSetting.confirmSaveMessage') }}</p>
        <CAlert color="info" class="mb-0 mt-2" style="font-size: 13px;">
          <i class="fi fi-rr-info mr-2"></i>
          {{ $t('receiptSetting.branchSyncNotice') }}
        </CAlert>
        <CAlert color="warning" class="mb-0 mt-2" style="font-size: 13px;">
          <i class="fi fi-rr-exclamation mr-2"></i>
          {{ $t('receiptSetting.footerImageNotice') }}
        </CAlert>
        <template #footer>
          <CButton color="secondary" @click="confirmModal = false">{{ $t('cancel') }}</CButton>
          <CButton color="success" @click="savedata" :disabled="loading">
            {{ loading ? $t('saving') : $t('confirm') }}
          </CButton>
        </template>
      </CModal>
      <!-- ─── Modal: Crop Image ─── -->
      <CModal
        :show.sync="imgModal"
        :title="$t('receiptSetting.cropImage')"
        size="lg"
        centered
      >
        <div class="cropper-container">
          <VueCropper
            ref="cropper"
            :src="selectedFile"
            :aspect-ratio="NaN"
            :view-mode="1"
            style="max-height: 400px; width: 100%;"
          />
        </div>
        <template #footer>
          <CButton color="secondary" @click="imgModal = false">{{ $t('cancel') }}</CButton>
          <CButton color="primary" @click="editImg">{{ $t('receiptSetting.cropAndUpload') }}</CButton>
        </template>
      </CModal>
    </div>
  </div>
  <div v-else>
    <access-data></access-data>
  </div>
</template>

<script>

import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import pos from "@/services/local";
import { mapGetters } from "vuex";
import permis from "@/util/permission";
import util from "@/util/util";

export default {
  name: "ReceiptSetting",
  components: {
    VueCropper,
  },

  data() {
    return {
      loading: false,
      loadingButton: true,
      confirmModal: false,
      imgModal: false,
      selectedFile: "",
      uploadTarget: "", // 'footer1', 'footer2'
    };

  },

  async mounted() {
    await this.$store.dispatch("getUser");
    await this.$store.dispatch("getShopSetting");
    await this.$store.dispatch("getAllPOS");
  },

  computed: {
    ...mapGetters(["shops", "users", "shopsetting"]),
     isPermission() {
      return permis.findPermissionRead("setting", this.$route.path);
    },
    isEditShop() {
      return permis.findPermissionEdit("setting", this.$route.path);
    },
    receiptTypes() {
      return [
        this.$t('receiptSetting.abbreviatedTaxInvoice'),
        this.$t('receiptSetting.receipt'),
        this.$t('receiptSetting.custom'),
      ];
    },
    isEditData() {
      return permis.findPermissionEdit("setting", this.$route.path);
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId;
      },
      set(newValue) {
        return this.$store.dispatch("setShop", newValue);
      },
    },
    uid() {
      let shop = this.shops.find((i) => i.objectId === this.shopObjectId);
      return shop?.uid || localStorage.getItem("shopsUid");
    },
    datashop: {
      get() {
        return this.$store.getters.shopsetting;
      },
      set(newValue) {
        return this.$store.dispatch("setShopSetting", newValue);
      },
    },
    currentDate() {
      const now = new Date();
      const day = String(now.getDate()).padStart(2, "0");
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const year = now.getFullYear() + 543;
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
  },

  methods: {
    // ─── Change Receipt Type ───
    changeReceiptType(index) {
      this.$set(this.datashop, 'receiptType', index);
    },
    // ─── Upload Image ───
    triggerUpload(target) {
      this.uploadTarget = target;
      this.$refs.fileInput.click();
    },
    onFileSelect(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.imgModal = true;
      this.mime_type = file.type;
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.selectedFile = event.target.result;
          this.$nextTick(() => {
            this.$refs.cropper.replace(this.selectedFile);
          });
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
      // Reset input
      e.target.value = "";
    },
    editImg() {
      const croppedImage = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.uploadImage(croppedImage);
    },
    uploadImage(image) {
      const uid = this.uid || localStorage.getItem("shopsUid");
      // กำหนด ref ตาม uploadTarget
      // 1. ดึงนามสกุลไฟล์ (.png, .jpg ฯลฯ)
      let ext = "jpg"; // ค่าเริ่มต้น
      if (this.mime_type) {
        ext = this.mime_type.split("/")[1] || "jpg";
      } else if (typeof image === "string" && image.startsWith("data:image/")) {
        // หากไม่มี mime_type ให้ดึงจาก Base64 string
        ext = image.substring("data:image/".length, image.indexOf(";base64")) || "jpg";
      }

      // ปรับแต่งชื่อ jpeg ให้เป็น jpg เพื่อความสวยงาม (ถ้าต้องการ)
      if (ext === "jpeg") ext = "jpg";

      // 2. สร้างชื่อไฟล์ตาม Timestamp + นามสกุลไฟล์
      const timestamp = Date.now();
      const fileName = `${this.shopObjectId}_${this.uploadTarget}_${timestamp}.${ext}`;
      let ref = "";
      if (this.uploadTarget === "footer1") {
        ref = `${this.shopObjectId}_footer1`;
      } else if (this.uploadTarget === "footer2") {
        ref = `${this.shopObjectId}_footer2`;
      } else if (this.uploadTarget === "signature") {
        ref = `${this.shopObjectId}_signature`;
      }
      const data = {
        ref: ref,
        uid: uid,
        image: image,
      };

      pos
        .post("/images/v1.0/upload/shop/cover", data)
        .then((res) => {
          if (res.data.error.code === 0) {
            const fullUrl = res.data.data.url;
            if (this.uploadTarget === "footer1") {
              this.datashop.footerRemoteImagePath1 = fullUrl;
              this.datashop.footerImageName1 = fileName;
            } else if (this.uploadTarget === "footer2") {
              this.datashop.footerRemoteImagePath2 = fullUrl;
              this.datashop.footerImageName2 = fileName;
            } else if (this.uploadTarget === "signature") {
              this.$set(this.datashop, 'signatureRemoteImagePath', fullUrl);
              this.$set(this.datashop, 'signatureImageName', fileName);
            }

            this.imgModal = false;
            this.$toast.success(this.$t("receiptSetting.uploadSuccess"));
          } else {
            this.$toast.error(this.$t("receiptSetting.uploadError"));
          }
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error(this.$t("receiptSetting.uploadError"));
        });
    },
    removeFooterImage(target) {
      if (target === 1) {
        this.datashop.footerRemoteImagePath1 = "";
        this.datashop.footerImageName1 = "";
      } else if (target === 2) {
        this.datashop.footerRemoteImagePath2 = "";
        this.datashop.footerImageName2 = "";
      }
    },
    removeSignatureImage() {
      this.$set(this.datashop, 'signatureRemoteImagePath', '');
      this.$set(this.datashop, 'signatureImageName', '');
    },

    // ─── Save Data ───
    savedata() {
      const uid = this.uid || localStorage.getItem("shopsUid");
      this.loading = true;
      const headers = {
        shopObjectId: util.sanitizeShopObjectId(this.shopObjectId),
      };
      pos({
        method: "post",
        url: "/api/v1.0/" + uid + "/Shop/updateconfig",
        headers: headers,
        data: this.datashop,
      })
        .then(() => {
          setTimeout(() => {
            this.loading = false;
            this.confirmModal = false;
            this.$toast.success(this.$t("saveSuccess"));
            this.$store.dispatch("getShop");
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.confirmModal = false;
          this.$toast.error(this.$t("receiptSetting.saveError"));
        });
    },
  },
};
</script>


<style scoped>


.notice-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #fef3cd;
  border: 1px solid #ffc107;
  border-radius: 6px;
  padding: 10px 14px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #856404;
}

.notice-box i {
  font-size: 16px;
  flex-shrink: 0;
}
/* ─── BASE LAYOUT ─── */
.booking-settings-container {
  padding: 24px;
  background-color: #f8fafc;
  border-radius: 6px;
  margin: 10px auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: calc(100vh - 80px);
}

/* ─── HEADER BAR ─── */
.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 16px;
  margin-bottom: 16px;
  flex-shrink: 0;
}

.header-section h2 {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.btn-save {
  background-color: #10b981;
  color: #fff;
  border: none;
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-save:hover:not(:disabled) {
  background-color: #059669;
}

.btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ─── INFO ALERT ─── */
.info-alert {
  font-size: 13px;
  margin-bottom: 16px;
  flex-shrink: 0;
}

/* ─── ROW LAYOUT ─── */
.receipt-layout {
  flex-grow: 1;
  overflow: hidden;
}

/* ─── SCROLLABLE ZONE (LEFT) ─── */
.scrollable-content {
  height: calc(100vh - 250px);
  overflow-y: auto;
  padding-right: 12px;
}

.scrollable-content::-webkit-scrollbar {
  width: 6px;
}

.scrollable-content::-webkit-scrollbar-track {
  background: transparent;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 10px;
}

/* ─── PREVIEW PANEL (RIGHT) ─── */
.preview-panel {
  position: sticky;
  top: 0;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  height: calc(100vh - 260px);
  display: flex;
  flex-direction: column;
}

.preview-panel-header {
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.preview-panel-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #334155;
  margin: 0;
}

.preview-panel-body {
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.preview-panel-body::-webkit-scrollbar {
  width: 6px;
}

.preview-panel-body::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 10px;
}

/* ─── SECTION CARDS ─── */
.section-card {
  background-color: #ffffff;
  padding: 24px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  margin-bottom: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}

.section-card h3 {
  font-size: 16px;
  font-weight: 600;
  color: #334155;
  margin: 0 0 16px 0;
}

.section-header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
}

.section-header-flex h3 {
  margin: 0;
}

/* ─── FORM ROWS ─── */
.form-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
}

.border-bottom {
  border-bottom: 1px solid #f1f5f9;
}

.desc-main {
  font-size: 14px;
  color: #475569;
  font-weight: 500;
  margin: 0;
}


.input-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  margin-bottom: 6px;
  margin-top: 8px;
}

.form-control {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  color: #334155;
  transition: border-color 0.2s;
}

.form-control:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-group {
  margin-bottom: 16px;
}

/* ─── FOOTER IMAGES ─── */
.footer-images-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.footer-image-box {
  display: flex;
  flex-direction: column;
}

.image-upload-area {
  width: 100%;
  height: 140px;
  border: 2px dashed #e2e8f0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
  overflow: hidden;
  margin-top: 8px;
}

.image-upload-area:hover {
  border-color: #3b82f6;
  background-color: #f8fafc;
}

.image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #94a3b8;
}

.image-placeholder i {
  font-size: 32px;
}

.image-placeholder span {
  font-size: 12px;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image-filename {
  font-size: 12px;
  color: #64748b;
  margin-top: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.btn-remove-image-corner {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgba(220, 38, 38, 0.9);
  color: #fff;
  border: none;
  font-size: 14px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
  z-index: 2;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.btn-remove-image-corner:hover {
  background-color: rgba(185, 28, 28, 1);
  transform: scale(1.1);
}

/* ─── CROPPER ─── */
.cropper-container {
  max-height: 400px;
  width: 100%;
  overflow: hidden;
}

.cropper-container img {
  max-width: 100%;
  max-height: 400px;
  display: block;
}

/* ─── RECEIPT PREVIEW (PAPER) ─── */
.receipt-paper {
  background: #fff;
  width: 100%;
  max-width: 300px;
  padding: 24px 18px;
  font-family: "Courier New", monospace;
  font-size: 12px;
  text-align: center;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.receipt-logo .logo-img {
  max-width: 80px;
  max-height: 60px;
  margin-bottom: 8px;
}

.receipt-queue {
  font-size: 18px;
  font-weight: bold;
  color: #1e293b;
  margin-bottom: 4px;
  letter-spacing: 1px;
}

.receipt-shop-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 4px;
}

.receipt-branch {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
}

.receipt-type-label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
}

.receipt-divider {
  border-top: 1px dashed #94a3b8;
  margin: 8px 0;
}

.receipt-info-line {
  font-size: 11px;
  text-align: left;
  margin-bottom: 2px;
}

.receipt-items {
  text-align: left;
}

.receipt-item-header {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  font-weight: bold;
  margin-bottom: 4px;
}

.receipt-item-row {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  margin-bottom: 2px;
}

.receipt-item-sub {
  font-size: 10px;
  color: #64748b;
  margin-bottom: 4px;
  text-align: left;
}

.receipt-item-plu {
  font-size: 10px;
  color: #475569;
  text-align: left;
  margin-bottom: 4px;
}

.receipt-total {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin: 4px 0;
  text-align: right;
}

.receipt-total-big {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: bold;
  margin: 6px 0;
}

.receipt-total-amount {
  font-size: 16px;
  font-weight: bold;
}

.receipt-payment {
  text-align: left;
}

.receipt-vat-note {
  font-size: 10px;
  color: #475569;
  margin: 4px 0;
}

.receipt-footer-text {
  font-size: 11px;
  margin-top: 4px;
}

.receipt-footer-img img {
  max-width: 100%;
  max-height: 60px;
  margin-top: 8px;
}

.receipt-powered {
  font-size: 10px;
  color: #94a3b8;
  margin-top: 12px;
}

.text-right {
  text-align: right;
}

/* ─── UTILITIES ─── */
.mt-3 {
  margin-top: 12px;
}

.mb-3 {
  margin-bottom: 12px;
}

.text-center {
  text-align: center;
}

/* ─── RESPONSIVE ─── */
@media (max-width: 991px) {
  .booking-settings-container {
    height: auto;
    padding: 16px;
  }

  .info-alert {
    font-size: 12px;
  }

  .preview-panel {
    position: relative;
    height: auto;
    max-height: 500px;
    margin-top: 20px;
  }

  .scrollable-content {
    height: auto;
    max-height: none;
    overflow-y: visible;
  }
}

@media (max-width: 768px) {
  .booking-settings-container {
    padding: 12px;
  }

  .header-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .header-section h2 {
    font-size: 18px;
  }

  .section-header-flex {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .section-card {
    padding: 16px;
  }

  .footer-images-grid {
    grid-template-columns: 1fr;
  }

  .form-row {
    padding: 10px 0;
  }

  .desc-main {
    font-size: 13px;
  }

  .preview-panel {
    max-height: none;
  }

  .receipt-paper {
    padding: 16px 12px;
  }

  /* Cropper modal */
  .cropper-container {
    max-height: 300px;
  }

  .cropper-container img {
    max-height: 300px;
  }
}

/* ─── Extra small (mobile < 480px) ─── */
@media (max-width: 480px) {
  .header-section h2 {
    font-size: 16px;
  }

  .btn-save {
    padding: 8px 16px;
    font-size: 13px;
  }

  .section-card h3 {
    font-size: 14px;
  }

  .image-upload-area {
    height: 120px;
  }

  .receipt-paper {
    font-size: 10px;
    padding: 12px 10px;
  }
}

</style>

